import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../assets/lottie/rentable.json';

type Props = {
  width: number;
  height: number;
};
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
const RentableAd = ({ width, height }: Props) => {
  return <Lottie options={defaultOptions} height={height} width={width} />;
};

export default RentableAd;
